module.exports = __webpack_public_path__ + "static/media/step-one-small.2f772c5e.jpg";